import React, { memo } from 'react'
import './Button.scss'
import ClipLoader from 'react-spinners/ClipLoader'

const Button = (props) => {
  const { children, className = 'btn-primary', onClick, disabled, loading = false, loaderColor = '#fff', style, loaderSize = 20 } = props
  return (
    <button
      id={props.id ? props.id : ''}
      type='button' className={`btn ${className}`}
      onClick={onClick} disabled={disabled}
      style={style}
    >
      {
        loading
          ? (
            <ClipLoader color={loaderColor} size={loaderSize} />
            )
          : (
              children
            )
      }
    </button>
  )
}
export default memo(Button)
